<ng-container *ngIf="!(srvRpDesign.isMobile$ | async)">
  <div class="bg-white">
    <div class="px-0 px-sm-3 mx-3 my-5">
      <div class="col-12 font-dialog-instructions-title d-flex justify-content-center" [ngStyle]="UIUtilityService.getHeaderStyle()">
        <span>{{ data.instructionGroupData.title| translate }}</span>
      </div>
  
      <div class="item-center m-5">
        <mat-icon svgIcon="falInfoCircle" class="icon-size-70 icon-center" [ngStyle]="UIUtilityService.getHeaderStyle()"></mat-icon>
      </div>
      
      <div class="mt-4 mx-1 font-dialog-instructions-content">
        <div class="mb-2" *ngFor="let instruction of data.instructionGroupData.instructions; index as i">
          <span *ngIf="data.instructionGroupData.withIndexedInstructions && instruction.displayCondition" class="font-am-17">
            {{ instruction.index }}. </span>
          <span [ngClass]="instruction.style">
            {{ instruction.instruction | translate }}
          </span>
          
        </div>
      </div>
  
      <div class="mt-4 mx-1">
        <div class="mb-3" *ngFor="let tip of data.instructionGroupData.tipList">
          <span class="font-dialog-instructions-content">{{ tip.label | translate }}</span>
          <div class="mt-2 mx-1 font-dialog-instructions-content">
            <div *ngFor="let message of tip.tipsMessage; index as idx">
              <span [ngClass]="getClass(tip, idx)">
                {{ message | translate}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="(srvRpDesign.isMobile$ | async)">
  <div class="bg-white p-3">
    <div class="mobile-font-dialog-instructions-title item-center" [ngStyle]="UIUtilityService.getHeaderStyle()">
      <span>{{ data.instructionGroupData.title| translate }}</span>
    </div>

    <div class="item-center m-3">
      <mat-icon svgIcon="falInfoCircle" class="icon-size-50 icon-center" [ngStyle]="UIUtilityService.getHeaderStyle()"></mat-icon>
    </div>
    
    <div class="mobile-font-dialog-instructions-content">
      <div class="mb-2" *ngFor="let instruction of data.instructionGroupData.instructions; index as i">
        <span *ngIf="data.instructionGroupData.withIndexedInstructions && instruction.displayCondition">
          {{ instruction.index }}. </span>
        {{ instruction.instruction | translate }}
      </div>
    </div>

    <div class="mt-3">
      <div class="mb-2" *ngFor="let tip of data.instructionGroupData.tipList">
        <span class="mobile-font-dialog-instructions-content">{{ tip.label | translate }}</span>
        <div class="mt-2 mx-1 mobile-font-dialog-instructions-content">
          <div *ngFor="let message of tip.tipsMessage; index as idx">
            <span [ngClass]="getClass(tip, idx)">
              {{ message | translate}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>